import { AlertCircle, Check } from "lucide-react";
import { cn } from "@/lib/utils";

interface MappingStatsBarProps {
  totalPersons: number;
  resolvedCount: number;
  fuzzyCount: number;
  unresolvedCount: number;
}

export function MappingStatsBar({
  totalPersons,
  resolvedCount,
  fuzzyCount,
  unresolvedCount,
}: MappingStatsBarProps) {
  if (totalPersons === 0) return null;

  const allResolved = resolvedCount === totalPersons;
  const pct = Math.round((resolvedCount / totalPersons) * 100);

  return (
    <div className="space-y-0">
      <div className="flex items-center gap-6 px-4 py-2 text-sm border border-border rounded-lg bg-muted/30">
        <span className={cn(
          "flex items-center gap-1.5 font-medium",
          allResolved ? "text-success" : "text-foreground"
        )}>
          <Check className="h-3.5 w-3.5" />
          {resolvedCount} resolved
        </span>

        {fuzzyCount > 0 && (
          <span className="flex items-center gap-1.5 text-amber-600">
            <span className="h-2 w-2 rounded-full bg-amber-400" />
            {fuzzyCount} fuzzy
          </span>
        )}

        {unresolvedCount > 0 && (
          <span className="flex items-center gap-1.5 text-destructive">
            <AlertCircle className="h-3.5 w-3.5" />
            {unresolvedCount} unresolved
          </span>
        )}

        <span className="text-muted-foreground ml-auto">
          of {totalPersons} total
        </span>
      </div>

      <div className="h-1 rounded-full bg-muted overflow-hidden mx-1">
        <div
          className={cn(
            "h-full rounded-full transition-all duration-300",
            allResolved ? "bg-success" : resolvedCount > 0 ? "bg-amber-400" : "bg-destructive"
          )}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
